import React, { useMemo } from 'react';

import { Dropdown } from 'semantic-ui-react';

import { getRoleOptions } from './RoleSelector.utils';

export default function RoleSelector({ role, onRoleChange, disabled }) {
  const options = useMemo(() => getRoleOptions(), []);

  return (
    <Dropdown
      selection
      fluid
      options={options}
      onChange={(_, { value }) => onRoleChange(value)}
      value={role}
      selectOnBlur={false}
      selectOnNavigation={false}
      disabled={disabled}
    />
  );
}
